require('./coverageWrapper.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

// @ utils
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ components
const Coverages = require('./coverages');
const InsuranceRequestRelatedLeaveModalWrapper = require('../insuranceRequestWizard/insuranceRequestRelatedLeaveModalWrapper/insuranceRequestRelatedLeaveModalWrapper')
const { INSURANCE_USABILITY_IMPROVEMENTS } = require('constants/flagBasedFeatures');
const InsuranceRequestWizardStep3PlanModal = require('../insuranceRequestWizard/insuranceRequestWizardStep3/insuranceWizardStep3Components/insuranceRequestWizardStep3PlanModal');

// @ constants
const { PLANS: { BASIC }, PAYMENT_TYPE } = require('../../insuranceConstants/insuranceRequestHome');
const { SECOND_STEP, THIRD_STEP, FOURTH_STEP } = require('constants/index');

class CoverageWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nextButtonClicked: false
        };

        this.handleBackButtonCallback = this.handleBackButtonCallback.bind(this);
        this.handleNextButtonCallback = this.handleNextButtonCallback.bind(this);
        this.onHandleModalClose = this.onHandleModalClose.bind(this);
        this.handleInsurancePlanModal = this.handleInsurancePlanModal.bind(this);
    }

    componentWillReceiveProps() {
        const { immInsuranceWizard, onChangeShowCoverageDetailTable, isPostAppraisal } = this.props;
        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const associatingClient = immInsuranceWizardStep3.get('isFetchingSelectPlan') || immInsuranceWizardStep3.get('isLinkingInProgress');
        if (associatingClient && this.state.nextButtonClicked && !isPostAppraisal) {
            onChangeShowCoverageDetailTable();
        }
    }

    componentWillUnmount() {
        const { linkClientSuccessInitialState } = this.props;
        this.setState({ nextButtonClicked: false });
        linkClientSuccessInitialState();
    }

    handleNextButtonCallback(selectedPlan) {
        const {
            currentPlan,
            onhandleSelectPlanInDetailTable,
            setData,
            didPlanChangeIndetailTable
        } = this.props;

        const chosenPlan = currentPlan || selectedPlan;
        const selectedPlanInDetailTable = didPlanChangeIndetailTable ? selectedPlan : chosenPlan;
        this.setState({ nextButtonClicked: true });

        if (selectedPlan !== currentPlan) {
            setData(FOURTH_STEP, {
                paymentType: PAYMENT_TYPE.ANNUAL
            });
        }

        onhandleSelectPlanInDetailTable(selectedPlanInDetailTable);
    }

    handleBackButtonCallback() {
        const { onChangeShowCoverageDetailTable, setData } = this.props;

        setData(THIRD_STEP, {
            step3LoadingFromDetailsTable: true
        });

        onChangeShowCoverageDetailTable();
    }

    buildButtons(associatingClient) {
        const { selectedPlan, onhandleCancel } = this.props;

        let nextButtonClick = () => this.handleNextButtonCallback(selectedPlan);

        return (
            <React.Fragment>
                <div className="coverages-detail-view-cc__bottom-left">
                    <OKButton
                        modifier="link-ghost"
                        onClick={onhandleCancel}
                    >
                        <FormattedText value="buttonsActions-cancel" format="firstUppercase" />
                    </OKButton>
                </div>
                <div className="coverages-detail-view-cc__bottom-right">
                    <OKButton
                        modifier="ghost"
                        leftIcon="icon-anterior"
                        size="regular"
                        disabled={associatingClient}
                        onClick={this.handleBackButtonCallback}
                    >
                        <FormattedText value="insuranceRequestHome-back" />
                    </OKButton>
                    <OKButton
                        id="btnAcceptConditions"
                        size="regular"
                        modifier="secondary"
                        rightIcon="icon-siguiente"
                        loading={associatingClient}
                        onClick={nextButtonClick}
                    >
                        <FormattedText value="insuranceRequestHome-step3ApplyFor" />
                    </OKButton>
                </div>
            </React.Fragment>
        );
    }

    onHandleModalClose() {
        const { setData } = this.props;
        setData(THIRD_STEP, { basicPlanModalValidation: false });
    }

    handleInsurancePlanModal(immInsuranceWizardStep3) {
        const { validateStep } = this.props;
        const associatingClient = immInsuranceWizardStep3.get('isFetchingSelectPlan') || immInsuranceWizardStep3.get('isLinkingInProgress');
        const basicPlanModalValidation = immInsuranceWizardStep3.get('basicPlanModalValidation');

        return (
            <InsuranceRequestWizardStep3PlanModal
                isOpen={basicPlanModalValidation}
                loading={associatingClient}
                handleRequestClose={this.onHandleModalClose}
                onRequestAccept={() => validateStep(FOURTH_STEP, true)}
            />
        )
    }

    render() {
        const {
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizard,
            selectedPlan,
            currentPlan,
            isRelated,
            onhandleChangeSelectedPlanInStateComponent,
            clearRequest,
            cancelingSimulation
        } = this.props;

        const immInsuranceWizardStep2 = immInsuranceWizard.getIn(['steps', SECOND_STEP]);
        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const associatingClient = immInsuranceWizardStep3.get('isFetchingSelectPlan') || immInsuranceWizardStep3.get('isLinkingInProgress');
        const chosenPlan = currentPlan || selectedPlan;

        const tableDetailsTitle = formatText('insuranceRequestHome-step3DetailsTitle');
        const insuranceUsabilityImprovementsFlag = !!immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);

        const leaveModal = isRelated && (
            <InsuranceRequestRelatedLeaveModalWrapper
                immInsuranceWizard={immInsuranceWizard}
                clearRequest={clearRequest}
                cancelingSimulation={cancelingSimulation}
            />
        );

        return (
            <section className="col-xs-10 coverages-detail-view-cc__main-container">
                <OKBoxTitle
                    value={tableDetailsTitle}
                    inline={true}
                />
                <header className="coverages-detail-view-cc__table-title">
                    <FormattedText value="insuranceRequestHome-step3DetailsSubtitle" />
                </header>
                <Coverages
                    insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                    isRelated={isRelated}
                    onhandleChangeSelectedPlanInStateComponent={onhandleChangeSelectedPlanInStateComponent}
                    immInsuranceState={immInsuranceState}
                    immInsuranceWizardStep={immInsuranceWizardStep3}
                    propertyInformation={immInsuranceWizardStep2}
                    chosenPlan={chosenPlan}
                    selectedPlan={selectedPlan}
                />
                <div className="coverages-detail-view-cc__bottom-buttons">
                    {this.buildButtons(associatingClient)}
                </div>
                {leaveModal}
                {insuranceUsabilityImprovementsFlag && this.handleInsurancePlanModal(immInsuranceWizardStep3)}
            </section>
        )
    }
}

CoverageWrapper.propTypes = {
    cancelingSimulation: PropTypes.func,
    clearRequest: PropTypes.func,
    currentPlan: PropTypes.string,
    didPlanChangeIndetailTable: PropTypes.bool.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    immInsuranceState: PropTypes.object.isRequired,
    immInsuranceWizard: PropTypes.object.isRequired,
    isPostAppraisal: PropTypes.bool,
    isRelated: PropTypes.bool,
    linkClientSuccessInitialState: PropTypes.func,
    onChangeShowCoverageDetailTable: PropTypes.func.isRequired,
    onhandleCancel: PropTypes.func,
    onhandleChangeSelectedPlanInStateComponent: PropTypes.func.isRequired,
    onhandleSelectPlanInDetailTable: PropTypes.func.isRequired,
    selectedPlan: PropTypes.string,
    setData: PropTypes.func.isRequired,
    validateStep: PropTypes.func,
};

CoverageWrapper.defaultProps = {
    onhandleCancel: () => { },
    isRelated: false,
    isPostAppraisal: false,
    selectedPlan: BASIC,
    currentPlan: '',
    clearRequest: () => { },
    cancelingSimulation: () => { },
    didPlanChangeIndetailTable: false,
    linkClientSuccessInitialState: () => { },
};

module.exports = CoverageWrapper;
